import pub from './../public'
const type = pub.getLang();

const language={
    "zh-hk":{
        login:"用户登入",
        email:"請輸入你的登入電郵地址",
        password:"請輸入你的登入密碼",
        login:"登入",
        forget:"忘記密碼",
        register:"註冊會員",
        other:"其他登入方式",
        slogn:"在\"House730\"中打開 ",
        open:"打開",
        emptyEmail:"請填寫電郵",
        emptyPwd:"請填寫登入密碼",
        emptyCode:"驗證碼不能為空",
        error:"登入電郵地址與密碼不符,請重新輸入",
        refuse:"登入失敗,請聯繫管理員",
        emailReg:"電郵格式錯誤",
        networkError:"網絡不穩定,請再嘗試"
    },
    "zh-cn":{
        email:"请输入你的登入电邮地址",
        password:"请输入你的登入密码",
        login:"登入",
        forget:"忘记密码",
        register:"注册会员",
        other:"其他登入方式",
        slogn:"在\"House730\"中打开",
        open:"打开",
        emptyEmail:"请填写电邮",
        emptyPwd:"请填写电邮登入密码",
        emptyCode:"验证码不能为空",
        error:"登入电邮地址与密码不符，请重新输入",
        refuse:"登录失败,请联系管理员",
        emailReg:"电邮格式错误",
        networkError:"网络不稳定,请再尝试"
    },
    "en-us":{
        email:"Login email",
        password:"Login password",
        login:"Login",
        forget:"Forgot Password",
        register:"Register",
        other:"Other Login Methods",
        slogn:"Open In \"House730\" APP",
        open:"Open",
        emptyEmail:"Login E-mail cannot be empty",
        emptyPwd:"Login Password cannot be empty",
        emptyCode:"Verification Code  cannot be empty",
        error:"Wrong user name or password.",
        refuse:"Login failed, please contact the administrator",
        emailReg:"Email format error",
        networkError:"Network unstable, please try again"
        
    },
}
export default language[type]